import {configReducer} from './config';
import {tickerReducer} from './ticker';

let rootReducers = {
	  Config: configReducer,
    Ticker: tickerReducer
}

export default rootReducers;
